import React from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import QRCode from "react-qr-code";

function QRDialog(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog disableRestoreFocus className="muvika-qr-dialog" open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_songbook_url_as_qrcode}</DialogTitle>
      <DialogContent sx={{textAlign: "center"}}>
        <QRCode value={props.url} />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="success" onClick={props.onClose}>OK</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default QRDialog;